import { PageHero } from "@/components/Section";
import Reveal from "@/components/Reveal";
import CTAButton from "@/components/CTAButton";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/content";

export default function FaqsPage() {
  return (
    <>
      <PageHero
        eyebrow="FAQs"
        title="Straight answers about meals, delivery and allergies."
        intro="Where a policy is not final yet, we say so rather than promising something we cannot yet guarantee."
      />

      <section className="py-14 sm:py-20">
        <div className="mbm-container grid gap-12 lg:grid-cols-[1fr_0.55fr] lg:items-start">
          <Reveal>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`faq-${i}`}
                  className="border-b border-line"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="py-5 text-left font-heading text-base font-semibold text-coralInk hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-sm leading-relaxed text-cocoa/70">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal delay={120} className="lg:sticky lg:top-28">
            <div className="rounded-card bg-surface shadow-soft p-6 sm:p-7">
              <h2 className="font-heading text-lg font-semibold">Still unsure about something?</h2>
              <p className="mt-2.5 text-sm leading-relaxed text-cocoa/70">
                Allergies, portions, delivery timing, school access — ask us directly and a real
                person from our team will answer.
              </p>
              <div className="mt-6 flex flex-col gap-3">
                <CTAButton to="/contact" data-testid="faq-contact-cta">
                  Contact the team
                </CTAButton>
                <CTAButton to="/get-started" variant="outline" data-testid="faq-early-access-cta">
                  Start your plan
                </CTAButton>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
